export class DisconnectEventModel {
    static { this.EVENT_TYPE = 'disconnectEvent'; }
    constructor(info, address) {
        this.info = info;
        this.address = address;
    }
}
//# sourceMappingURL=disconnect-event-model.js.map